import React from 'react';
import { useParams, Link } from 'react-router-dom';

export default function ArticlePage() {
  const { id } = useParams();
  
  return (
    <div className="container mx-auto px-4 py-16 max-w-4xl">
      <Link to="/nieuws" className="text-red-600 hover:text-red-800 mb-6 inline-block">← Terug naar nieuws</Link>
      <article className="bg-white rounded-2xl shadow-lg overflow-hidden">
        <img src={`https://picsum.photos/seed/article${id}/800/400`} alt="Article" className="w-full h-80 object-cover" />
        <div className="p-8">
          <div className="flex items-center gap-4 mb-6">
            <span className="bg-red-100 text-red-600 px-3 py-1 rounded-full text-sm font-semibold">Politiek</span>
            <span className="text-gray-500 text-sm">30 maart 2026 • 5 min lezen</span>
          </div>
          <h1 className="text-4xl font-bold mb-6">Artikel Titel</h1>
          <p className="text-xl text-gray-600 mb-8">Dit is een voorbeeldartikel. Inhoud wordt geladen uit de database.</p>
          <div className="prose max-w-none text-gray-700">
            <p>Hier zou de volledige artikelinhoud staan, geladen from the CMS database.</p>
          </div>
        </div>
      </article>
    </div>
  );
}
